import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <AboutSection />
        <CommentsSection />
        <IndexSection />
        <MediaSection />
        <ContactSection />
        <RankingSection />
        <FaqSection />
        <AppSection />
        <CardsSection />
        <CarouselSection />
        <UpdatesSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}